var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50 25.98c-13.246 0-24.02 10.773-24.02 24.02 1.3164 31.863 46.723 31.855 48.035 0 0-13.246-10.773-24.02-24.02-24.02z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50 19.004c1.2969 0 2.3438-1.0508 2.3438-2.3438v-8.0938c-0.050781-3.082-4.6406-3.0859-4.6914 0v8.0938c0 1.2969 1.0508 2.3438 2.3438 2.3438z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.766 28.082c2.2148 2.1406 5.4609-1.1016 3.3164-3.3164l-5.7227-5.7227c-2.2148-2.1406-5.4609 1.0977-3.3164 3.3164l5.7227 5.7227z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.656 47.656h-8.0938c-3.082 0.050781-3.0859 4.6406 0 4.6914h8.0938c3.082-0.050781 3.0859-4.6406 0-4.6914z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.766 71.918-5.7227 5.7227c-1.4961 1.3945-0.34766 4.0742 1.6602 4.0039 0.60156 0 1.1992-0.23047 1.6602-0.6875l5.7227-5.7227c2.1406-2.2148-1.0977-5.4609-3.3164-3.3164z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m50 80.996c-1.2969 0-2.3438 1.0508-2.3438 2.3438v8.0938c0.050781 3.082 4.6406 3.0859 4.6914 0v-8.0938c0-1.2969-1.0508-2.3438-2.3438-2.3438z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m75.234 71.918c-2.2148-2.1406-5.4609 1.0977-3.3164 3.3164l5.7227 5.7227c0.45703 0.45703 1.0586 0.6875 1.6602 0.6875 2.0039 0.070313 3.1562-2.6094 1.6602-4.0039l-5.7227-5.7227z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m91.438 47.656h-8.0938c-3.082 0.050781-3.0859 4.6406 0 4.6914h8.0938c3.082-0.050781 3.0859-4.6406 0-4.6914z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m73.578 28.77c0.60156 0 1.1992-0.23047 1.6602-0.6875l5.7227-5.7227c0.91797-0.91406 0.91797-2.4023 0-3.3164-0.91797-0.91797-2.4023-0.91797-3.3164 0l-5.7227 5.7227c-1.4961 1.3945-0.34766 4.0742 1.6602 4.0039z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.db3e71f51ca888a63e04418e3a8bf93e.svg";
export { ForwardRef as ReactComponent };